import { useEffect, useReducer, useRef, useState } from "react";
import AppButton from "../elements/AppButton";
import MoneyInput from "../elements/MoneyInput";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import DropFile, { DropFileFunctions } from "../elements/DropFile";
import {
  selectAccessToken,
  selectNtumaAccount,
} from "../../features/auth/authSlice";
import useApiRequest from "../../helpers/api_request";
import { APP_STATUS, BASE_URL } from "../../helpers/constants";
import { AxiosError } from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  TypeDonationLink,
  TypeSaveLinkData,
  selectDonationLinkById,
} from "../../features/donationlinks/donationLinksSlice";
import AppSpinner from "../elements/AppSpinner";
import {
  AddtionalInputsModal,
  LogoModal,
  TypeExtraInput,
} from "../payment_links/NewPaymentLink";

import { getFileNameFromUlr, notEmpty } from "../../helpers/commons";
import { TypeNtumaDigitalItem } from "../../features/ntumadigitalItems/ntumaDigitalItemssSlice";

type TypeExtraInputState = TypeExtraInput[];
type TypeExtraInputAction = {
  type: string;
  payload: {
    data?: TypeExtraInput;
    index?: number;
  };
};


const extraInputsReducer = (
  state: TypeExtraInputState,
  action: TypeExtraInputAction
): TypeExtraInputState => {
  switch (action.type) {
    case "add":
      return action.payload.data ? [...state, action.payload.data] : state;
    case "remove":
      
      if (typeof action.payload.index === 'number') {
        return state.filter((input, index) => index !== action.payload.index);
      }
      return state;
    case "edit":
      if (typeof action.payload.index === 'number' && action.payload.data) {
        return state.map((item, index) => {
          if (index === action.payload.index) {
           
            return { ...item, ...action.payload.data };
          }
          return item;
        });
      }
      return state;
    default:
      return state;
  }
};

const NewNtumaDigitalItem = () => {
  const [extraInputs, extraInputDispatch] = useReducer(extraInputsReducer, []);
  const [showExtraInputsModal, setShowExtraInputsModal] = useState(false);
  const [showLogoModal, setShowLogoModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [linkType, setLinkType] = useState("public");
  const [categoryType, setCategoryType] = useState("Ebooks (PDF)");
  const [btnLabelText, setBtnLabelText] = useState("Create Product");
  const [productTitleText, setProductTitleText] = useState("Create");
  const [productId, setProductId] = useState(0);

  const [target, setTarget] = useState(0);

  const [sale_price, setPrice] = useState(0);
  const [original_price, setOriginalPrice] = useState(0);
  const [showOriginalPrice, setShowOriginalPrice] = useState(false);

 
  const [editingInputIndex, setEditingInputIndex] = useState<number | null>(null);

  const [savingLinkStatus, setSavingLinkStatus] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const apiRequest = useApiRequest();
  const accessToken = useAppSelector(selectAccessToken);
  const { ref } = useParams();
  const [selectedDonationLink, setSelectedDonationLink] =
    useState<TypeDonationLink | null>(null);
  const [isLoadingLink, setIsLoadingLink] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  const storageUrl = process.env.REACT_APP_STORAGE_URL;
  const dropFileRef = useRef<DropFileFunctions>(null);
  const [beneficiary, setBeneficiary] = useState<string | null>("");

  
  const extraInputAdded = (extraInput: TypeExtraInput, index: number | null) => {
    if (index !== null) {
        extraInputDispatch({
            type: "edit",
            payload: {
                data: extraInput,
                index: index,
            },
        });
    } else {
        extraInputDispatch({
            type: "add",
            payload: {
                data: extraInput,
            },
        });
    }
    setShowExtraInputsModal(false);
    setEditingInputIndex(null); 
  };

  useEffect(() => {
    if (ref != undefined && selectedDonationLink === null) {
      getDonationLinkDetails();
    }
  }, []);

  const onSaveDonationLink = async () => {
    
    if (title == null || title === "") {
      toast.error("Product title is missing");
      return;
    }

    if (description == null || description === "") {
      toast.error("Product description is missing");
      return;
    }
    if (sale_price === null || sale_price === undefined || isNaN(sale_price)) {
      toast.error("Product price is missing");
      return;
    }

    

    if (imageUrl == null) {
      if (!fileUrl) {
        toast.error("Product image is missing");
        return;
      }

      
      const fileExtension = (fileUrl as string).split(".").pop()?.toLowerCase();

      const validImageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];

      if (!fileExtension || !validImageExtensions.includes(fileExtension)) {
        toast.error("Invalid file type. Please upload an image file.");
        return;
      }
    }

    
    if (fileUrl == null) {
      if (!fileUrl) {
        toast.error("Product file is missing");
        return;
      }
      
    }

    let message = "Item Added";
    let saveUrl = BASE_URL + "/api/donation-link/create_digital_item";
    if (selectedDonationLink !== null) {
      saveUrl =
        BASE_URL +
        "/api/donation-link/update_digital_item/" +
        selectedDonationLink.id;
      message = "Item Updated";
    }

    setSavingLinkStatus(true);

    apiRequest({
      method: "post",
      url: saveUrl,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
      data: {
        title, // required
        description, // optional
        image: imageUrl || null,
        file: fileUrl,
        price: sale_price,
        original_price: original_price,
        category: categoryType,
        type: linkType,
        extra_fields: extraInputs || [],
        seller_note: null,
        buyer_note: null,
      },
    })
      .then((response) => {
        console.log("ITEMS-CREATE" + JSON.stringify(response));
        dispatch(
          showToastMessage({
            message: message,
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
        setSavingLinkStatus(false);
        navigate("/ntuma-digital-items"); // redirect to list
      })
      .catch((error) => {
        console.log("ITEMS" + JSON.stringify(error));
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          toast.error(data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setSavingLinkStatus(false);
      });
  };

 
  const getDonationLinkDetails = async () => {
    setIsLoadingLink(true);
    await apiRequest({
      method: "get",
      url: BASE_URL + "/api/donation-link/details_degital_item/" + ref,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
      .then((response) => {
        console.log("DATAS-DIGTITAL-ITEMS" + JSON.stringify(response));

        setSelectedDonationLink(response.data.details);

        console.log("DATAS-returned" + JSON.stringify(response));

        //const donationLink: TypeDonationLink = response.data.details;

        const ntumaDigitalItem: TypeNtumaDigitalItem = response.data.details;
        if (ntumaDigitalItem != null) {
          setBtnLabelText("Update Product");
          setProductTitleText("Update");
          setProductId(ntumaDigitalItem.id);
          setTitle(ntumaDigitalItem.title);
          if (
            ntumaDigitalItem.original_price != null &&
            ntumaDigitalItem.original_price > 0
          ) {
            setOriginalPrice(
              ntumaDigitalItem.original_price
                ? ntumaDigitalItem.original_price
                : 0
            );
          }

          setDescription(
            ntumaDigitalItem.description ? ntumaDigitalItem.description : ""
          );

          //  setLinkType(ntumaDigitalItem.type);

          if (ntumaDigitalItem?.category) {
            // Make sure it exactly matches one of the option values
            const matchingOption = [
              "Public",
              "Private",
              "public",
              "private",
            ].find((opt) => opt === ntumaDigitalItem.type);

            setLinkType(matchingOption || "");
          }

          setPrice(ntumaDigitalItem.price ? ntumaDigitalItem.price : 0);
          //setCategoryType(ntumaDigitalItem.category ? ntumaDigitalItem.category : "")

          if (ntumaDigitalItem?.category) {
            // Make sure it exactly matches one of the option values
            const matchingOption = [
              "Ebooks (PDF)",
              "Business Templates (Word, Excel, PDF)",
              "Presentation Templates (PowerPoint)",
              "Spreadsheet Tools (Excel, Google Sheets)",
              "Printables (Planners, Checklists, Calendars)",
              "Recipes & Meal Plans",
              "Digital Certificates",
              "Digital Planners (GoodNotes, Notability)",
              "Software or Code Snippets",
            ].find((opt) => opt === ntumaDigitalItem.category);

            setCategoryType(matchingOption || "");
          }

          setImageUrl(ntumaDigitalItem.image ? ntumaDigitalItem.image : "");
          setFileUrl(ntumaDigitalItem.file ? ntumaDigitalItem.file : "");
          if (ntumaDigitalItem.extra_fields) {
            for (const extra_field of ntumaDigitalItem.extra_fields) {
              extraInputDispatch({
                type: "add",
                payload: {
                  data: extra_field,
                },
              });
            }
          }
        }
        setIsLoadingLink(false);
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          toast.error(data.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.error("Something went wrong", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setIsLoadingLink(false);
      });
  };

  const handleFileUrl = async (url: string) => {
    if (!url) {
      toast.error("Product file is missing");
      return;
    }

    try {
      // Use HEAD request instead of full download for size check
      const res = await fetch(url, { method: "HEAD" });

      if (!res.ok) {
        toast.error("Could not access the uploaded file");
        return;
      }

      // Get file size from Content-Length header (more efficient)
      const contentLength = res.headers.get("content-length");

      if (contentLength) {
        const fileSize = parseInt(contentLength, 10);
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (fileSize > maxSize) {
          const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);
          toast.error(
            `File size (${fileSizeMB}MB) exceeds the 5MB limit. Please compress your file or use ZIP format.`
          );
          return;
        }
      } else {
        // Fallback to blob method if Content-Length is not available
        const fullRes = await fetch(url);
        const blob = await fullRes.blob();
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (blob.size > maxSize) {
          const fileSizeMB = (blob.size / (1024 * 1024)).toFixed(1);
          toast.error(
            `File size (${fileSizeMB}MB) exceeds the 5MB limit. Please compress your file or use ZIP format.`
          );
          return;
        }
      }

      setFileUrl(url);
      // toast.success("File uploaded successfully!");
    } catch (err) {
      console.error("File validation error:", err);
      toast.error("Could not validate file. Please try uploading again.");
    }
  };

  return (
    <div>
      <div className="card mb-5">
        <div className="card-body flex flex-col px-4 py-4 min-h-half-screen">
          <div className="flex">
            <nav className="flex justify-between " aria-label="Breadcrumb">
              <ol className="inline-flex items-center mb-3 sm:mb-0">
                <li>
                  <div className="flex items-center">
                    <Link to="/ntuma-digital-items" className=" card-title ">
                      Ntuma digital Item
                    </Link>
                  </div>
                </li>
                <span className="mx-2 text-gray-400">/</span>
                <li aria-current="page">
                  <div className="flex items-center">
                    <h5 className=" card-title ">{productTitleText}</h5>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
          {isLoadingLink ? (
            <div>
              <AppSpinner />
            </div>
          ) : (
            <div className=" h-fit flex-grow  ">
              <div className=" w-2/3 mt-3">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 "
                >
                  Title / Name of product
                </label>
                <input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  type="text"
                  id="name"
                  className="form-input-2"
                  placeholder=""
                />
              </div>
              <div className=" w-2/3 mt-4">
                <label
                  htmlFor=""
                  className="block text-sm font-medium text-gray-700 "
                >
                  Description
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="form-input-2"
                  name=""
                  id=""
                  cols={30}
                  rows={7}
                ></textarea>
              </div>

              {/*
                               <div className=" w-2/3 mt-3">
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 ">Beneficiary</label>
                                    <input value={(beneficiary)?beneficiary:""} onChange={(e) => setBeneficiary(e.target.value)} type="text" id="name" className="form-input-2" placeholder="" />
                                </div>
                               */}

              <div className="w-2/3 mt-4">
                <label
                  htmlFor=""
                  className="block text-sm font-medium text-gray-700"
                >
                  Product Type
                </label>
                <select
                  value={linkType}
                  onChange={(e) => setLinkType(e.target.value)}
                  name=""
                  className="form-input-2"
                  id=""
                >
                  <option value="public">Public</option>
                  <option value="private">Private</option>
                </select>
              </div>
              {linkType === "public" && (
                <span className="text-red-600 text-xs">
                  Public means the product will be advertised on our website
                </span>
              )}

              <div className="w-2/3 mt-4">
                <label
                  htmlFor=""
                  className="block text-sm font-medium text-gray-700 "
                >
                  Product Categories
                </label>
                <select
                  value={categoryType}
                  onChange={(e) => setCategoryType(e.target.value)}
                  name=""
                  className="form-input-2"
                  id=""
                >
                  <option value="Ebooks (PDF)">Ebooks (PDF)</option>
                  <option value="Business Templates (Word, Excel, PDF)">
                    Business Templates (Word, Excel, PDF)
                  </option>
                  <option value="Presentation Templates (PowerPoint)">
                    Presentation Templates (PowerPoint)
                  </option>
                  <option value="Spreadsheet Tools (Excel, Google Sheets)">
                    Spreadsheet Tools (Excel, Google Sheets)
                  </option>
                  <option value="Printables (Planners, Checklists, Calendars)">
                    Printables (Planners, Checklists, Calendars)
                  </option>
                  <option value="Recipes & Meal Plans">
                    Recipes & Meal Plans
                  </option>
                  <option value="Digital Certificates">
                    Digital Certificates
                  </option>
                  <option value="Digital Planners (GoodNotes, Notability)">
                    Digital Planners (GoodNotes, Notability)
                  </option>
                  <option value="Software or Code Snippets">
                    Software or Code Snippets
                  </option>
                </select>
              </div>

              <div className="w-2/3 mt-4">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Sale price (UGX) *
                </label>
                <MoneyInput
                  value={sale_price}
                  onChange={(value) => setPrice(value)}
                  className="form-input-2"
                />
              </div>
              <p className="block text-xs font-medium text-gray-700">
                Set price to <span className="text-red-500">0</span> for a free
                product.
              </p>

              {/* Checkbox and Label */}
              <div className="custom-check2 mt-1">
                <input
                  type="checkbox"
                  id="checkbox1"
                  checked={showOriginalPrice}
                  onChange={() => setShowOriginalPrice(!showOriginalPrice)}
                />
                <label
                  htmlFor="checkbox1"
                  className="text-sm font-medium text-gray-700"
                >
                  Show striked out original price
                </label>
              </div>

              {/* Conditionally rendered div */}
              {showOriginalPrice && (
                <div className="w-2/3 mt-4">
                  <label
                    htmlFor="originalPrice"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Original price (UGX) *
                  </label>
                  <MoneyInput
                    value={original_price}
                    onChange={(value) => setOriginalPrice(value)}
                    className="form-input-2"
                  />
                </div>
              )}

              <div className="w-1/3 mt-4">
                <label
                  htmlFor="image"
                  className="block text-sm font-medium text-gray-700 "
                >
                  Product Image
                </label>

                {notEmpty(imageUrl) ? (
                  <p className="mt-2">
                    <a
                      target="_blank"
                      className=" text-green-600"
                      href={storageUrl + "/" + imageUrl}
                    >
                      {" "}
                      {getFileNameFromUlr(imageUrl)}{" "}
                    </a>{" "}
                    <small
                      onClick={() => {
                        setImageUrl(null);
                      }}
                      className="text-red-600  cursor-pointer"
                    >
                      (change)
                    </small>
                  </p>
                ) : (
                  <DropFile
                    ref={dropFileRef}
                    getFileUrl={(fileUrl) => {
                      const validExtensions = [
                        "jpg",
                        "jpeg",
                        "png",
                        "gif",
                        "svg",
                        "webp",
                        "avif",
                      ];
                      const extension = fileUrl.split(".").pop()?.toLowerCase();

                      if (extension && validExtensions.includes(extension)) {
                        setImageUrl(fileUrl);
                      } else {
                        toast.error(
                          "Only image files (jpg, jpeg, png, gif,svg, webp, avif) are allowed."
                        );
                      }
                    }}
                    StorageFolder="certificates"
                    SubText="Product Image"
                  />
                )}
              </div>
              {imageUrl && (
                <button
                  onClick={() => setShowLogoModal(true)}
                  type="button"
                  className="btn-light"
                >
                  Update product image
                </button>
              )}

              <div className="w-1/3 mt-4">
                <label
                  htmlFor="file"
                  className="block text-sm font-medium text-gray-700"
                >
                  Product file (Max.5MBs)
                </label>

                {notEmpty(fileUrl) ? (
                  <p className="mt-2">
                    <a
                      target="_blank"
                      className="text-green-600"
                      href={storageUrl + "/" + fileUrl}
                    >
                      {getFileNameFromUlr(imageUrl)}
                    </a>
                    <small
                      onClick={() => setFileUrl(null)}
                      className="text-red-600 cursor-pointer"
                    >
                      (change)
                    </small>
                  </p>
                ) : (
                  <DropFile
                    ref={dropFileRef}
                    // getFileUrl={(url) => setFileUrl(url)}
                    getFileUrl={(url) => handleFileUrl(url)}
                    StorageFolder="certificates"
                    SubText="Product File"
                    // acceptedFileTypes={['.pdf', '.docx', '.zip', '.mp4']}
                  />
                )}
              </div>

              <div className=" flex gap-2  mt-4">
                
                
                <button onClick={() => {
                    setEditingInputIndex(null); 
                    setShowExtraInputsModal(true);
                }} type="button" className="btn-light ">+ Extra Inputs</button>
                

                {fileUrl && (
                  <button
                    onClick={() => setShowLogoModal(true)}
                    type="button"
                    className="btn-light"
                  >
                    Update product file
                  </button>
                )}
              </div>
            
              {extraInputs.map((item: TypeExtraInput, key) => (
                <div className="w-2/3 mt-4" key={key}>
                  <label
                    htmlFor="email"
                    className="0 text-sm font-medium text-gray-700 flex items-center"
                  >
                    {item.label}

                    
                    <svg onClick={() => {
                        setEditingInputIndex(key); 
                        setShowExtraInputsModal(true); 
                    }} xmlns="http://www.w3.org/2000/svg" className="ml-2 text-blue-600 cursor-pointer" width="18" height="18" viewBox="0 0 24 24">
                        <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1l1-4L16.5 3.5z" />
                    </svg>
                    
                    <svg
                      onClick={() => {
                        extraInputDispatch({
                          type: "remove",
                          payload: {
                            index: key,
                          },
                        });
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      className="ml-1 text-red-600 cursor-pointer"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 7h16m-10 4v6m4-6v6M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"
                      />
                    </svg>
                  </label>

                  {item.type === "text" && (
                    <input
                      type="text"
                      className="form-input-2"
                      placeholder=""
                      readOnly
                    />
                  )}
                  {item.type === "multi-text" && (
                    <textarea
                      className="form-input-2"
                      name=""
                      id=""
                      cols={30}
                      rows={5}
                      readOnly
                    ></textarea>
                  )}
                  {item.type === "select" && (
                    <select name="" className="form-input-2" id="" disabled>
                      {item.options.map((option, key2) => (
                        <option key={key2} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  )}
                  {item.type === "checkbox" &&
                    item.options.map((item, key3) => (
                      <div key={key3} className="custom-check2 mt-1">
                        <input type="checkbox" id={"checkbox1" + key3} disabled />
                        <label
                          htmlFor={"checkbox1" + key3}
                          className="text-sm font-medium text-gray-700 "
                        >
                          {item}
                        </label>
                      </div>
                    ))}
                  {item.type === "radio" &&
                    item.options.map((item, key4) => (
                      <div key={key4} className="custom-radio mt-1">
                        <input name="radio" type="radio" id={"radio" + key4} disabled />
                        <label
                          htmlFor={"radio" + key4}
                          className="text-sm font-medium text-gray-700 "
                        >
                          {item}
                        </label>
                      </div>
                    ))}
                </div>
              ))}
              <LogoModal
                isOpen={showLogoModal}
                onClose={() => setShowLogoModal(false)}
              />

              
              <AddtionalInputsModal
                onClose={() => {
                    setShowExtraInputsModal(false);
                    setEditingInputIndex(null); 
                }}
                isOpen={showExtraInputsModal}
                extraInputAdded={(extraInput, index) => extraInputAdded(extraInput, index)}
                initialInput={editingInputIndex !== null ? extraInputs[editingInputIndex] : undefined}
                editingIndex={editingInputIndex}
              />
              <AppButton
                callBackFun={() => onSaveDonationLink()}
                showLoader={savingLinkStatus}
                spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black"
                className="prim-btn-1 mt-6"
                text={btnLabelText}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default NewNtumaDigitalItem;
